import { Component } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { DayOfTheWeek, Frequencies } from '@payroll/interfaces/schedule.interface';
import { Schedule } from '@payroll/interfaces/schedule.interface';

@Component({
    selector: 'app-form-create-tenant',
    templateUrl: './create-tenant.template.html',
})
export class CreateTenantForm extends BaseForm {
    firstPayDate: Date;
    frequency: Frequencies;
    dayOfTheWeek: DayOfTheWeek;
    firstDayOfTheMonth: number;
    secondDayOfTheMonth: number;
    daysInArrears: number;

    getSchedule(): Schedule {
        const schedule = {
            frequency: this.frequency,
            firstPayDate: this.firstPayDate,
            daysInArrears: this.daysInArrears,
            dayOfTheWeek: null,
            daysOfTheMonth: null,
        };

        switch (this.frequency) {
            case 'monthly':
                schedule.daysOfTheMonth = [this.firstDayOfTheMonth];
                schedule.dayOfTheWeek = null;
                break;
            case 'semimonthly':
                schedule.daysOfTheMonth = [this.firstDayOfTheMonth, this.secondDayOfTheMonth];
                schedule.dayOfTheWeek = null;
                break;
            default:
                schedule.daysOfTheMonth = null;
                schedule.dayOfTheWeek = this.dayOfTheWeek;
        }

        return schedule;
    }
}
